export interface IFacilityStoreState {
	facilities: IFacilityModel[]
	selectedIdentifier: string | null
	loading: boolean
	initialized: boolean
}

export const useFacilityStore = defineStore('facilityStore', () => {
	const _state = reactive<IFacilityStoreState>({
		facilities: [],
		selectedIdentifier: null,
		loading: false,
		initialized: false,
	})

	const fetchFacilities = async () => {
		_state.loading = true
		try {
			_state.facilities = await ApiService.fetchFacilities()
		} finally {
			_state.loading = false
		}
	}

	const selectFacility = (identifier: string) => {
		_state.selectedIdentifier = identifier
		facilityStorage.set(identifier)
	}

	const initFromStorage = () => {
		const saved = facilityStorage.get()
		const exists = saved && _state.facilities.some(f => f.identifier === saved)

		if (exists) {
			_state.selectedIdentifier = saved
		} else if (_state.facilities.length > 0) {
			const first = _state.facilities[0].identifier
			_state.selectedIdentifier = first
			facilityStorage.set(first)
		}

		_state.initialized = true
	}

	const reset = () => {
		_state.facilities = []
		_state.selectedIdentifier = null
		_state.loading = false
		_state.initialized = false
	}

	const getSelectedFacility = computed(
		() => _state.facilities.find(f => f.identifier === _state.selectedIdentifier) ?? null,
	)

	const getSelectedIdentifier = computed(() => _state.selectedIdentifier)

	const isReady = computed(() => _state.initialized && _state.selectedIdentifier !== null)

	const isLoading = computed(() => _state.loading)

	const hasFacilities = computed(() => _state.facilities.length > 0)

	const isVirtualFacility = computed(() => Boolean(getSelectedFacility.value?.isVirtual))

	return {
		state: _state,
		fetchFacilities,
		selectFacility,
		initFromStorage,
		reset,
		getSelectedFacility,
		getSelectedIdentifier,
		isReady,
		isLoading,
		hasFacilities,
		isVirtualFacility,
	}
})
